import { render } from "./product-upsell.vue?vue&type=template&id=8a2bb5fe"
import script from "./product-upsell.vue?vue&type=script&lang=js"
export * from "./product-upsell.vue?vue&type=script&lang=js"

import "./product-upsell.vue?vue&type=style&index=0&id=8a2bb5fe&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__